import {
  CONTAINER_OPTIONS,
  CONTENT_LAYOUT_OPTIONS,
  HEADING_ALIGNMENT_OPTIONS,
  MODULE_FILL_TYPE_OPTIONS,
  MODULE_FLOW_DIRECTION_OPTIONS,
  TITLE_SIZE_OPTIONS,
  TITLE_TYPE_OPTIONS,
} from '@/common/constants';
import { useModuleStyles } from '@/common/hooks';
import { BaseModuleProps } from '@/common/types';
import { HeadingBlock, HeadingBlockProps } from '@/components/blocks/HeadingBlock/HeadingBlock';
import { ImageBlockProps } from '@/components/blocks/ImageBlock/ImageBlock';
import { CTAProps } from '@/components/CTA';
import { TestimonialCard } from '@/components/TestimonialCard';
import { TestimonialCardProps } from '@/components/TestimonialCard/TestimonialCard';
import { SingleTestimonial } from './SingleTestimonial';

import React from 'react';
import styles from './Testimonials.module.scss';

export interface TestimonialsProps extends BaseModuleProps {
  testimonials: TestimonialCardProps[];
  singleTestimonialCta?: CTAProps;
  singleTestimonialImage?: ImageBlockProps;
}

export const Testimonials: React.FC<TestimonialsProps> = ({
  anchorTag = undefined,
  container = CONTAINER_OPTIONS.CONTAINED,
  fillType = MODULE_FILL_TYPE_OPTIONS.BASE,
  gradientFillToken,
  layout = CONTENT_LAYOUT_OPTIONS.CONTENT_TRAILING,
  eyebrow,
  title,
  titleSize = TITLE_SIZE_OPTIONS.SMALL,
  titleType = TITLE_TYPE_OPTIONS.H2,
  bodyRichTextAsHTML,
  alignment = HEADING_ALIGNMENT_OPTIONS.CENTER,
  ctas,
  caption,
  testimonials,
  singleTestimonialCta,
  singleTestimonialImage,
}) => {
  const headingConfig: HeadingBlockProps = {
    eyebrow,
    title,
    titleSize,
    titleType,
    bodyRichTextAsHTML,
    alignment,
    ctas,
    caption,
  };

  const { sectionStyles, moduleBaseStyles } = useModuleStyles({
    container,
    fillType,
    gradientFillToken,
    flowDirection: MODULE_FLOW_DIRECTION_OPTIONS.COLUMN,
    layout,
    moduleClassName: 'module-testimonials',
    styles,
  });

  return (
    <section className={sectionStyles} id={anchorTag}>
      <div className={moduleBaseStyles}>
        <HeadingBlock {...headingConfig} className={styles['testimonial-heading-block']} />
        {testimonials.length > 1 ? (
          <div className={styles.multi_testimonials_container}>
            {testimonials.map((testimonial, idx) => (
              <TestimonialCard
                key={testimonial.author + '_' + idx}
                author={testimonial.author}
                authorAvatarUrl={testimonial.authorAvatarUrl}
                quote={testimonial.quote}
                className={styles['testimonial-card-color']}
              />
            ))}
          </div>
        ) : (
          <SingleTestimonial
            testimonial={testimonials[0]}
            cta={singleTestimonialCta}
            image={singleTestimonialImage}
            className={styles['single-testimonial-card-color']}
          />
        )}
      </div>
    </section>
  );
};
